import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { LoginService } from '../../login/login.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

  private requestPendings: number = 0;

  constructor(private loaderService: LoaderService, private loginService: LoginService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let isSkipedRequest = this.loaderService.isRequestSkiped(request);
    if (request.method!='GET' || !isSkipedRequest) this.requestPendings++;
    this.loaderService.onPendingRequest.emit({ pendingRequests: this.requestPendings, loadingPercent: 0 });


    var token = localStorage.getItem("token");
    const clonedRequest = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
    //console.log(clonedRequest);

    return next.handle(clonedRequest).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (request.method != 'GET' || !isSkipedRequest) this.requestPendings--;
          this.loaderService.removeSkipRequest(request);
          this.loaderService.onPendingRequest.emit({ pendingRequests: this.requestPendings, loadingPercent: 0 });
        }
        return event;
      }),
      catchError((err) => {
        this.loaderService.removeSkipRequest(request);
        if (request.method != 'GET' || !isSkipedRequest) this.requestPendings--;
        this.loaderService.onPendingRequest.emit({ pendingRequests: this.requestPendings, loadingPercent: 0 });
        if (err.status == 401) {
          this.loginService.logout();
        } else if (err.status == 404) {
          this.loginService.notFound();
        } else {
          return throwError(err);
        }
      })
    );

  }
}
